import {
  HeaderShownContext,
  useHeaderHeight as useRNHeaderHeight,
} from 'expo-router/react-navigation';
import { use } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const ANDROID_DEFAULT_HEADER_HEIGHT = 56;

export default function useCustomHeaderHeight() {
  const { top } = useSafeAreaInsets();
  const headerHeight = useRNHeaderHeight();

  if (process.env.EXPO_OS === 'android') {
    const parentHeaderShown = use(HeaderShownContext);
    return parentHeaderShown ? ANDROID_DEFAULT_HEADER_HEIGHT + top : 0;
  }

  return headerHeight;
}
